import { Map } from "immutable";
import * as React from "react";
import 'intersection-observer';
import { InView } from 'react-intersection-observer';
import { Action, IOWidget, mk_widget, } from "widgets-for-react";
import { CMSState, Link } from "../../../../cms/blocks/types.gen";
import { blockInviewHandler } from "../../../../drupal/rendering/inview_utils.mod";
import { cleanMultipleHttps, getClassName, link, linkWrapper } from "../../../../cms/blocks/utils.gen";
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types";
import { List } from 'immutable'
import { parseImage } from "../../../../drupal/drupal_to_cms.mod";
import { extra_images } from "../../../utils/extra_images.mod";
import { UpdateItemProps, UpdatesBlock } from "./latestUpdates";

export type latestUpdatesBlockProps = {
  index: number
  field_title: string
  field_latest_update_item: List<latestUpdateItemBlockProps>
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type latestUpdateItemBlockProps = {
  field_label: string
  field_image?: ParsedMediaImage
  field_link: Link
}

export type latestUpdatesBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function latestUpdatesBlock<customBlockData>(
  props: latestUpdatesBlockProps,
  options?: { style: latestUpdatesBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, never>, Action<CMSState<customBlockData, extra_images, never>>> {
  return (cmsState: CMSState<customBlockData, extra_images, never>) =>
    mk_widget({
      run: _ => {
        return (
          <InView
            as="section"
            onChange={(inView) => blockInviewHandler('latestUpdates', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
            triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
            threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
            id={`io-${options && options.key ? options.key : props.index}`}
            className={"container-fluid bg-light my-5"}
            key={options && options.key ? options.key : `block-${props.index}`}
          >
            {UpdatesBlock(
              {
                isStyleguide: false,
                title: props.field_title,
                items: props.field_latest_update_item
                  .map((e, i) =>
                    (
                      {
                        title: e!.field_link.title,
                        category: e!.field_label,
                        link: cleanMultipleHttps(e!.field_link.url),
                        field_image: e!.field_image,
                      }
                    ) as UpdateItemProps
                  ).toArray(),
              }
            )}
          </InView>
        )
      },
    })
}
